import { combineReducers } from 'redux'

import authSlice from './authSlice'
import locationSlice from './locationSlice'
import recordsSlice from './recordsSlice'
import carePlanSlice from './carePlanSlice'
import themeSlice from './themeSlice'
import cgmSlice from './cgmSlice'
import landingPageSlice from './landingPageSlice'
import authenticationSlice from './authenticationSlice'
// export all reducers
export const rootReducer = combineReducers({
  auth: authSlice,
  location: locationSlice,
  records: recordsSlice,
  carePlan: carePlanSlice,
  theme: themeSlice,
  cgm: cgmSlice,
  landingPage: landingPageSlice,
  authentication: authenticationSlice,
})

// export all action
export * from './authSlice'
export * from './locationSlice'
export * from './recordsSlice'
export * from './carePlanSlice'
export * from './themeSlice'
export * from './cgmSlice'
export * from './landingPageSlice'
export * from './authenticationSlice'
